import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumContentReducer(state = initialState.verumContent, action: any) {
  switch (action.type) {
    case types.SAVE_VERUMCONTENT_SUCCESS:
      return action.verumContent;
    default:
      return state;
  }
}
